import { axios } from '@/utils/request'
import qs from 'qs'

export const clientApi = {
  getClientListData,
  getClientDetail,
  addAppClient,
  updateAppClient,
  deleteAppClient,
  checkClientId,
  getClientStats,
  changeClientStatus,
  /* 型号管理 */
  getClientTenantOptions,
  getClientModels,
  addClientModel,
  removeClientModel,
  /* 获取未授权的可选型号（添加弹窗用） */
  getAvailableModels,
  /* 设备管理 */
  getClientDevices,
  /* 租户-客户端 */
  getTenantClients,
  getTenantClientStats,
  assignClientsToTenant,
  removeClientFromTenant,
  getAvailableClients,
}

/* ========== 客户端基础 ========== */

/* 获取客户端列表 */
export function getClientListData(params) {
  return axios({
    url: '/device/app-client/page',
    method: 'get',
    params,
  })
}

/* 获取客户端详情 */
export function getClientDetail(id) {
  return axios({
    url: `/device/app-client/${id}`,
    method: 'get',
  })
}

/* 新增客户端 */
export function addAppClient(data) {
  return axios({
    url: '/device/app-client',
    method: 'post',
    data,
  })
}

/* 编辑客户端 */
export function updateAppClient(data) {
  return axios({
    url: `/device/app-client`,
    method: 'put',
    data,
  })
}

/* 删除客户端 */
export function deleteAppClient(id) {
  return axios({
    url: `/device/app-client/${id}`,
    method: 'delete',
  })
}

/** ClientId 唯一性校验 */
export function checkClientId(clientId, excludeId) {
  return axios({
    url: `/device/app-client/client-id/check`,
    method: 'get',
    params: { clientId, excludeId },
  })
}

/* 获取客户端统计 */
export function getClientStats() {
  return axios({
    url: '/device/app-client/statistics',
    method: 'get',
  })
}

/** 切换启用/禁用状态 */
export function changeClientStatus(id, data) {
  return axios({
    url: `/device/app-client/${id}/status`,
    method: 'put',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    }
  })
}

/* ========== 型号管理 ========== */

/* 获取该客户端已授权的型号列表 */
export function getClientModels(clientId, params) {
  return axios({
    url: `/device/app-client/${clientId}/type-auth/page`,
    method: 'get',
    params,
  })
}

/** 已分配该客户端的租户下拉 */
export function getClientTenantOptions(clientId) {
  return axios({
    url: `/device/app-client/${clientId}/tenant-options`,
    method: 'get',
  })
}

/* 给客户端添加型号授权（批量） */
export function addClientModel(clientId, data) {
  return axios({
    url: `/device/app-client/${clientId}/type-auth`,
    method: 'post',
    data,
  })
}

/* 移除某型号的授权 */
export function removeClientModel(clientId, typeId) {
  return axios({
    url: `/device/app-client/${clientId}/type-auth/${typeId}`,
    method: 'delete',
  })
}

/* 获取可选型号（用于添加弹窗，已按系列分组，排除已授权） */
export function getAvailableModels(clientId, params) {
  return axios({
    url: `/device/app-client/${clientId}/type-auth/available-types`,
    method: 'get',
    params,
  })
}

/* ========== 设备管理 ========== */

/* 获取客户端服务的设备列表 */
export function getClientDevices(clientId, params) {
  return axios({
    url: `/device/managements/clients/${clientId}/devices`,
    method: 'get',
    params,
  })
}

/* ========== 租户-客户端 ========== */

/* 租户已分配客户端分页列表（带分页） */
export function getTenantClients(params) {
  return axios({
    url: `/device/app-client/tenant/${params.tenantId}/list`,
    method: 'get',
    params,
  })
}

/** 租户下客户端统计卡片 */
export function getTenantClientStats(tenantId) {
  return axios({
    url: `/device/app-client/tenant/${tenantId}/statistics`,
    method: 'get',
  })
}

/* 给租户分配客户端（批量） */
export function assignClientsToTenant(tenantId, params) {
  return axios({
    url: `/device/app-client/tenant/${tenantId}`,
    method: 'post',
    data: params,
  })
}

/* 从租户移除某客户端 */
export function removeClientFromTenant(tenantId, clientId) {
  return axios({
    url: `/device/app-client/tenant/${tenantId}/${clientId}`,
    method: 'delete',
  })
}

/* 获取可分配的客户端列表（用于添加弹窗，标记已分配/未分配） */
export function getAvailableClients(params) {
  return axios({
    url: `/device/app-client/tenant/${params.tenantId}/available`,
    method: 'get',
    params,
  })
}
